import React from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { Image } from '@platzi/ui';
import Tag from '../../shared/Tag';

import styles from './Course.module.sass';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBadgeCheck } from '@fortawesome/pro-solid-svg-icons';
import 'dayjs/locale/es';
interface CourseInterface {
  badge_url: string;
  title: string;
  launch_date: string;
  content_duration: string;
  practice_duration: string;
  url: string;
  is_approved: boolean;
}

export const Course = (props: CourseInterface) => {
  dayjs.locale('es');
  const { t } = useTranslation();
  const isAfter = dayjs(props?.launch_date || dayjs()).isAfter(dayjs());

  const getCopyPublishedDate = () => {
    const publishedDate = dayjs(props?.launch_date).locale('es').format('DD [de] MMMM [de] YYYY');

    if(isAfter) {
      return `Lanzamiento el ${publishedDate}`;
    }
    return `${props.content_duration} ${t('route.course.contentHours')} ${props.practice_duration} ${t('route.course.practiceHours')}`
  }

  return (
    <a className={styles.Course} href={props.url}>
      <div className={styles.CourseInformation}>
        <Image src={props.badge_url} alt={props.title} />
        <div>
          <div className={styles.Course__header}>
            <h3>{props.title}</h3>
            {isAfter && (
              <Tag>
                {t('route.course.comingSoon')}
              </Tag>
            )}
          </div>
          <p>
            {getCopyPublishedDate()}
          </p>
        </div>
      </div>
      {props.is_approved && (
        <div className={styles.CourseProgressCont}>
          <FontAwesomeIcon icon={faBadgeCheck} />
          <p>{t('route.course.approved')}</p>
        </div>
      )}
    </a>
  );
};
